export const tableFont = {
  fontFamily: '"Hiragino Kaku Gothic ProN",Meiryo,"MS PGothic",sans-serif',
  fontSize: '12px;'
};
